import React from "react";
import { salesPurchaseStatusoptions } from "../helper-components/data";
import FilterRadioButtons from "../forms/filter-radio-buttons";

const SalesPurchaseFilter = ({ setFilterData, filterData, setCurrentPage }) => {
  const handleOrderStatusChange = (e) => {
    setFilterData({
      ...filterData,
      orderStatus: e.target.value,
    });
    setCurrentPage(1);
  };

  return (
    <div
      menuPortalTarget={document.body}
      style={{
        minWidth: "17rem",                
        zIndex: 999,
        top: "40px",
        right: "-5px",
        boxShadow: `0 12px 32px -8px var(--popover-shadow-color), 0 2px 6px -2px var(--popover-shadow-color)`,
      }}
      className="absolute  border border-[var(--popover-border-color)] border-solid border-1   py-2 px-2  bg-[var(--popover-bg-color)]  rounded-xl z-10 flex flex-col"
    >
      <span className="px-3 pt-1.5 pb-2.5 text-sm fw_600 text-[var(--popover-heading-fg-color)]">
        Filter by
      </span>
      <hr className="border-0 border-t border-[var(--popover-border-color)] -mx-2" />
      <div>
        <FilterRadioButtons
          name="order_sataus"
          label={"Order Status"}
          options={salesPurchaseStatusoptions}
          handleChange={handleOrderStatusChange}
          value={filterData?.orderStatus}
        />
      </div>
    </div>
  );
};

export default SalesPurchaseFilter;
